import 'regenerator-runtime/runtime.js';

import Swiper, { Autoplay, EffectFade, Navigation, Pagination, Thumbs } from 'swiper';
Swiper.use([Autoplay, EffectFade, Navigation, Pagination, Thumbs]);

import animations from './utils/animations';
import documents from './modules/documents';
import fixVhOnResize from './utils/fixVhOnResize';
import insights from './modules/insights';
import accordion from './modules/accordion';
import readerVoice from './modules/reader-voice';
import testimonials from './modules/testimonials';
import windowWidthResize from './utils/windowWidthResize';
import mobileMenu from './modules/mobile-menu';
import header from './modules/header';
import popup from './modules/popup';
import video from './modules/video';
import gformFix from './modules/gform-fix';
import appearanceAnimations from './modules/appearance-animations';
import scrollAnimations from './modules/scroll-animations';
import calendly from './modules/calendly';
import scrollTo from './modules/scroll-to';

(function ($) {
  const initMethods = [
    animations.init,
    documents,
    fixVhOnResize,
    insights,
    accordion,
    readerVoice,
    testimonials,
    windowWidthResize,
    mobileMenu,
    header,
    video,
    popup,
    gformFix,
    appearanceAnimations,
    scrollAnimations,
    calendly,
    scrollTo,
  ];

  $(() => {
    requestAnimationFrame(() => {
      for (let i = 0; i < initMethods.length; i += 1) {
        try {
          initMethods[i]($);
        } catch (error) {
          console.error(error);
        }
      }
    });
  });
}(window.jQuery));
